<template>
  <div>
    <v-navigation-drawer
      v-model="$root.profile.leftNav"
      color="background"
      left
      app
      hide-overlay
      disable-resize-watcher
      class="pt-0"
    >
      <template slot="prepend">
        <v-row justify="center" align-content="center" class="py-2">
          <v-btn
            @click="$router.push('/locations'); $root.leftNav = true"
            color="primary"
            text
            class="text-capitalize"
          >
            <v-icon left small>fas fa-arrow-left</v-icon>Back To Locations
          </v-btn>
        </v-row>
        <v-divider></v-divider>
      </template>
      <template slot="append">
        <v-row justify="center" align-content="center">
          <v-btn
            :to="`/profile/${$route.params.id}/store-delete`"
            block
            text
            color="error"
            class="text-capitalize"
            height="50px"
          >
            <v-icon left small>delete</v-icon>Delete Location
          </v-btn>
        </v-row>
      </template>
      <v-container>
        <v-layout column>
          <v-list-group no-action value="true">
            <template v-slot:activator>
              <v-list-item-title>Store Details</v-list-item-title>
            </template>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-info`"
            >
              <v-list-item-title>Basic Information</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-address`"
            >
              <v-list-item-title>Store Address</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-contact-info`"
            >
              <v-list-item-title>Store Contact</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-images`"
            >
              <v-list-item-title>Store Images</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-location-groups`"
            >
              <v-list-item-title>Location Groups</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-printers`"
            >
              <v-list-item-title>Printers</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group no-action value="true">
            <template v-slot:activator>
              <v-list-item-title>Hours Of Operation</v-list-item-title>
            </template>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-hours`"
            >
              <v-list-item-title>Store Hours</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-holiday-hours`"
            >
              <v-list-item-title>Holiday Hours</v-list-item-title>
            </v-list-item>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-delivery-hours`"
            >
              <v-list-item-title>Delivery Hours</v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-title>Location Settings</v-list-item-title>
            </template>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-delivery-zones`"
            >
              <v-list-item-title>Delivery Zones</v-list-item-title>
            </v-list-item> 
            <v-list-item
              v-for="(item,index) in settings"
              :key="item.name"
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/store-settings/${index}`"
            >
              <v-list-item-title>{{item.display_name}}</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-title>Clover Settings</v-list-item-title>
            </template>
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/clover-token-budler`"
            >
              <v-list-item-title>Budler Token</v-list-item-title>
            </v-list-item> 
            <v-list-item
              class="pl-11"
              active-class="primary--text"
              :to="`/profile/${$route.params.id}/clover-token-gr8table`"
            >
              <v-list-item-title>Gr8table Token</v-list-item-title>
            </v-list-item> 
          </v-list-group>

        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-scroll-x-transition mode="out-in">
      <router-view></router-view>
    </v-scroll-x-transition>
  </div>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
export default {
  async created() {
    await this.getLocationSettings()
    this.$root.leftNav = false
  },
  data() {
    return {
      settings: []
    }
  },
  methods: {
    async getLocationSettings() {
      let response
      try {
        response = await LocationAPI.getLocationSettings(this.$route.params.id)
      } catch (error) {
        return console.log(error)
      }
      this.settings = response.data.payload
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
